import { AnyAction } from 'redux';
import { ABDMHiuState } from '../models/abdmHIUModel';
import actionTypes from '../types/abdmHiuTypes';

const initialState: ABDMHiuState = {
 reloadList: 0,
 filters: {},
 searchClicked: 0,
 searchFilters: {},
};

const reducer = (
  state: any = initialState,
  action: AnyAction,
): any => {
  switch (action.type) {
    case actionTypes.RELOAD_HIU_LIST:
      return {
        ...state,
        reloadList: state.reloadList + 1,
      };
    case actionTypes.APPLY_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };
    case actionTypes.SEARCH_CLICKED:
      return{
        ...state,
        searchClicked: state.searchClicked + 1,
      };

    case actionTypes.SET_FILTER:
      return {
        ...state,
        searchFilters: {
          ...state.searchFilters,
          ...action.payload,
        },
    };

    case actionTypes.RESET_FILTER:
      return {
        ...state,
        searchFilters: {
          ...action.payload,
        },
    };
  default: return state;
 }
};

export { reducer as abdmHiuReducer };
